<template lang="html">
	<div>
		<h1>Server is under maintenance</h1>
	</div>
</template>
<script>
export default {
	name: "Maintenance",
	data: () => ({
	})
}
</script>